import React, {Component, Fragment} from 'react';
import PhoneForm from './PhoneForm';
import {connect} from "react-redux";

class PhoneAdd extends Component {

  constructor(props) {
    super(props);
  }

  // ----------------------
  // Computed
  // ----------------------

  get isLoading() {
    return this.props.isLoading.includes('updateUserPhones')
      || this.props.isLoadingMyProfile.includes('updateMyProfilePhones')
      || this.props.isLoadingMyDepartment.includes('updateMyDepartmentPhones')
  }
  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <PhoneForm
          isLoading={this.isLoading}
          onSave={formData => this.props.onSave(formData)} />
      </Fragment>
    );
  }
}


// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.users.isLoading,
    isLoadingMyProfile: state.myProfile.isLoading,
    isLoadingMyDepartment: state.myDepartment.isLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneAdd);

